var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.dashboardPath,"replace":""}},[_c('v-avatar',{attrs:{"size":"50"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }